module.exports = __webpack_public_path__ + "../assets/img/spinner.054d3711ae9ceabe1ae8861d48f92e65.gif";